import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	knowledgeBase: {
		id: 'servicedesk-knowledge-common.knowledge-hub-breadcrumb.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Title of the knowledge feature, used in breadcrumbs, sidebar items, etc',
	},
});
